import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45d6ffee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row badge-row" }
const _hoisted_2 = { class: "col-2" }
const _hoisted_3 = {
  key: 0,
  class: "col-2 badge-container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill bg-success" }, "Started", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "col-2 badge-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill bg-warning" }, "Paused", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "col-2 badge-container"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill bg-danger" }, "Interrupted", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "col-2 badge-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill bg-info" }, "Resumed", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 4,
  class: "col-2 badge-container"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill bg-primary" }, "Concluded", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "col-2 date-time-badge" }
const _hoisted_19 = { class: "col-2 user-badge" }
const _hoisted_20 = { class: "col-2 text-start description" }
const _hoisted_21 = { class: "pagination-controls" }
const _hoisted_22 = { class: "pagination" }
const _hoisted_23 = ["onClick"]

import { TaskEvent } from '@/stores/Tasks';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { computed, ComputedRef, Ref, ref } from 'vue';
import UserBadge from '@/components/UserBadge.vue';
import DateTimeBadge from '@/components/DateTimeBadge.vue';
import HideOverflowDescription from '@/components/HideOverflowDescription.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskEventInline',
  props: {
    events: {}
  },
  setup(__props: any) {

const employeeStore = useEmployeeStore();
const props = __props;


const currentPage: Ref<number> = ref(1);
const eventsPerPage: Ref<number> = ref(10);
const totalEvents: ComputedRef<number> = computed(() => props.events?.length);
const totalPages: ComputedRef<number> = computed(() => Math.ceil(totalEvents.value / eventsPerPage.value));

const paginatedEvents = computed(() => {
    if (!props.events) {
        return []; // Return an empty array if events are undefined
    }
    const startIndex = (currentPage.value - 1) * eventsPerPage.value;
    const endIndex = startIndex + eventsPerPage.value;
    return props.events.slice(startIndex, endIndex);
});


const changePage = (newPage: number) => {
    if (newPage === currentPage.value || newPage < 1 || newPage > totalPages.value) {
        return; // Don't do anything if it's the current page or out of bounds
    }
    currentPage.value = newPage;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedEvents.value, (event) => {
      return (_openBlock(), _createElementBlock("div", {
        key: event.id
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (event.event_type === 'ST')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : _createCommentVNode("", true),
            (event.event_type === 'PA')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true),
            (event.event_type === 'IN')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (event.event_type === 'RE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true),
            (event.event_type === 'CO')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(DateTimeBadge, {
              time: event.timestamp
            }, null, 8, ["time"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(UserBadge, {
              "user-id": event.employee
            }, null, 8, ["user-id"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("b", null, [
              _createVNode(HideOverflowDescription, {
                text: event.notes
              }, null, 8, ["text"])
            ])
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("nav", _hoisted_21, [
      _createElementVNode("ul", _hoisted_22, [
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: [
              _cache[0] || (_cache[0] = ($event: any) => (changePage(currentPage.value - 1))),
              _cache[1] || (_cache[1] = _withModifiers(($event: any) => (changePage(currentPage.value - 1)), ["prevent"]))
            ]
          }, "Previous ")
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["page-item", { active: currentPage.value === page }]),
            key: `page-${page}`
          }, [
            _createElementVNode("button", {
              class: "page-link",
              onClick: ($event: any) => (changePage(page))
            }, _toDisplayString(page), 9, _hoisted_23)
          ], 2))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
        }, [
          _createElementVNode("button", {
            class: "page-link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changePage(currentPage.value + 1)))
          }, "Next ")
        ], 2)
      ])
    ])
  ], 64))
}
}

})